import React from "react"
import { buildWhatsappLink } from "../../data/site"

type ServiceCTAProps = {
  prefill: string
  headline?: string
  buttonLabel?: string
}

export const ServiceCTA = ({
  prefill,
  headline,
  buttonLabel,
}: ServiceCTAProps) => (
  <section className="text-gray-700 body-font">
    <div className="container mx-auto px-5 py-12">
      <div className="lg:w-2/3 flex flex-col sm:flex-row sm:items-center items-start mx-auto">
        <h2 className="flex-grow sm:pr-16 text-xl md:text-2xl font-medium title-font text-gray-900">
          {headline ||
            "Está pronta para entrar nessa jornada de autoconhecimento comigo?"}
        </h2>
        <a
          href={buildWhatsappLink(prefill)}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-shrink-0 text-white bg-purple-500 border-0 py-3 px-8 focus:outline-none hover:bg-purple-600 rounded text-lg mt-6 sm:mt-0 mx-auto sm:mx-0"
        >
          {buttonLabel || "Agendar pelo WhatsApp"}
        </a>
      </div>
    </div>
  </section>
)
